// nanographql
let getOpname = /(query|mutation) ?([\w\d-_]+)? ?\(.*?\)? \{/

export default function gql(str) {
    str = Array.isArray(str) ? str.join('') : str;
    let name = getOpname.exec(str);
    return function (variables) {
        let data = { query: str }
        if (variables) data.variables = JSON.stringify(variables);
        if (name && name.length) {
            let operationName = name[2];
            if (operationName) data.operationName = name[2];
        }
        //return data;
        return window.axios.post('/graphql', data);
    }
}